export interface IDateConflict {
  type: string;
  date: string;
}

export default class DateConflict {
  type: string;
  date: string;

  constructor(data: IDateConflict) {
    this.type = data.type;
    this.date = data.date;
  }

  toJson(): Record<string, unknown> {
    const json: Record<string, unknown> = {};
    if (this.type !== null) json.type = this.type;
    if (this.date !== null) json.date = this.date;

    return json;
  }
}
